import SignInPage from '@portal/features/auth/SignInPage'
import { createFileRoute } from '@tanstack/react-router'

const RouteComponent = () => {
  return <SignInPage />
}

export const Route = createFileRoute('/signin/')({
  component: RouteComponent,
})
